export default {
  additionalInfo: 'Additional Info',
  qualification: 'Qualification',
  rank: 'Medical Practitioner Rank',
  schsRegistrationNumber: 'SCHS Registration Number',
  registrationNumber: 'Registration Number',
  schsExpiryDate: 'SCHS Expiry Date',
  expiryDate: 'Expiry Date',
  additionalContact: 'Additional Contact Info (Optional)',
  placeOfPractice: 'Place Of Practice',
  acceptAll: 'Accept all the following:',
  payNow: 'PAY NOW',
  quoteTimer: 'Quote Time Out',
  policyHolderMobile: 'Policy Holder Mobile',
  policyHolderEmail: 'Policy Holder Email',
  additionalMobileNumber: 'Enter additional mobile number',
  governmentPractice: 'Government #1',
  otpMessage:
    'Please note that we will send an OTP to the policy holder mobile number',
  iban: 'IBAN',
  ibanLabel:
    'We need your IBAN to make the payments and claims more safe and secured',
  addIban: 'Add IBAN',
  noIbansFound: 'No IBANs found',
  startsWithSA: 'Starts with SA',
  includesBankIdentifierCode: 'Include bank identifier code',
  ibanTotalNumber: 'Total 22 Numbers',
  ibanDrawerTitle: 'Please enter your IBAN Number',
  ibanDrawerSubtitle:
    'We need your IBAN to make the payments and claims more safe and secured',
  ibanAddedSuccessfully: 'IBAN added successfully',
  tabs: {
    overview: 'Overview',
    coverage: 'Coverage',
    benefits: 'Benefits',
    policyholderDetails: 'Policyholder Details',
    professionInfo: 'Profession Info',
    declarations: 'Declarations',
    policyInfo: 'Policy Info',
  },

  overview: {
    policyLimit: 'Policy Limit',
    deductible: 'Deductibles',
    noDeductible: 'No deductibles',
  },

  coverage: {
    policyLimit: 'Policy Limit',
    deductible: 'Deductibles',
    coverageDetails: 'Coverage Details',
    coveragePeriod: 'Coverage Period',
    effectiveDate: 'Effective Date',
    features: 'Features',
    retroactiveCover: 'Retroactive Cover',
    extendedReportingPeriod: 'Extended Reporting Period',
    noRetroactiveCover: 'No retroactive covers provided',
    noExtendedReportingPeriod: 'No extended reporting period options available',
  },

  benefits: {
    includedBenefits: 'Included Benefits',
    additionalBenefits: 'Additional Benefits',
    medicalMalpracticeCoverage: 'Medical Malpractice Coverage',
    legalDefense: 'Legal Defense',
    settlementCosts: 'Settlement Costs',
    courtAttendance: 'Court Attendance',
    retroactiveCoverage: 'Retroactive Coverage',
    extendedReporting: 'Extended Reporting Period',
    noRetroactiveCoverage: 'No retroactive coverage',
    noExtendedReporting: 'No extended reporting period',
  },

  policyInfo: {
    policyEffectiveDate: 'Policy Effective Date',
  },

  // Policyholder Details Section
  viewAll: 'View All',
  performingSurgeries: 'Performing Surgeries',
  experience: 'Experience',
  specialty: 'Specialty',
  nationalId: 'National ID',
  iqamaNumber: 'Iqama Number',
  personalAndProfessionalDetails: 'Personal & Professional Details',
  personalDetails: 'Personal Details',
  professionalDetails: 'Professional Details',
  policyholderDetails: {
    idNumber: 'ID Number',
    name: 'Name',
    dob: 'Date of Birth',
    nationality: 'Nationality',
    borderNumber: 'Border Number',
    sponsorNumber: 'Establishment Number',
    idSponsorNumber: 'Saudi ID/Iqama Number',
  },
  professionInfo: {
    speciality: 'Specialty',
    subSpeciality: 'Sub-Specialty',
    surgeryQuestion: 'Are you performing surgeries?',
    yearsOfExperience: 'Years Of Experience',
    regionOfPractice: 'Region Of Practice',
    placeOfPractice: 'Place Of Practice',
  },
  declarations: {
    previousPolicy: {
      title: 'Previous Policy Details',
      policyNumber: 'Policy Number',
      insuranceCompany: 'Insurance Company',
      expirationDate: 'Expiration Date',
      uninterruptedDuration: 'Uninterrupted Duration',
      effectiveDate: 'Effective Date',
      retroactiveDate: 'Retroactive Date',
    },
    disclaimer:
      'I hereby delcare that to the best of my knowledge and beleif, the above statements and particulars are complete and true and that I have not mis-stated or suppressed any material facts ( a material fact is one which is likely to influence <bold>{{insuranceCompany}}</bold> acceptance or assessment of this proposal. If any doubt whether facts are material, the should be disclosed). \nI declare that I previewed and agreed on Medical Malpractice Insurance. Submitting this request indicates the information in this request will be the basis of the contact for the policy to be issued.',
    paymentAuthorization:
      'I have authorized <bold>{{insuranceCompany}}</bold> and Tameeni to charge me the amount of {{paidAmount}} SAR as premium contribution on the selected payment channel as per the details in this request.',
    termsAndConditions: 'Kindly read and accept T&Cs to be able to proceed',
    termsAndConditionsLink: 'Terms And Conditions',
    addressVerificationError:
      'We were unable to verify the national address for the entered identity. Please ensure that a valid national address exists before proceeding.',
  },
  summaryDetails: {
    details: 'Summary Details',
    priceBreakdown: 'Price Breakdown',
    policyValue: 'Policy Price Amount',
    extendedReportingBenefit: 'Extended Reporting Period',
    retroactiveCoverage: 'Retroactive Cover',
    adminFees: 'Admin fees (non refundable)',
    subtotal: 'Sub Total',
    vat: 'VAT',
    totalAmount: 'Total Amount',
    includesVat: 'Inc. VAT',
    close: 'Close',
    tamaraHintTitle: 'Split by {{numberOfInstallments}} payments',
    tamaraHintDescription:
      'Buy the policy now and split your payment by {{numberOfInstallments}} monthly payments and benefit from the smart package',
    tabbyHintTitle: 'Split by {{numberOfInstallments}} payments',
    tabbyHintDescription:
      'Buy the policy now and split your payment by {{numberOfInstallments}} monthly payments and benefit from the smart package',
    schemeDiscount: 'Scheme Discount',
  },
  coupons: {
    availableCoupons: 'Available Coupons',
    couponsDescription: 'Coupons can be applied on payment',
    readMore: 'Read more',
    copyCode: 'Copy code',
    copied: 'Copied!',
    discount: 'Discount',
  },
  pointsRedemption: {
    useMyAvailablePoints: 'Use my available points',
    surplusPoints: 'Surplus points',
    referralPoints: 'Referral points',
    totalRedemption: 'Total redemption',
    availablePoints: 'Available points',
    redeemedAmount: 'Redeemed amount',
    disclaimer: 'The point redemption is non-refundable, subject to',
    termsAndConditions: 'Terms & Conditions',
    sliderPlaceholder:
      'Slider component will be implemented when SliderInput is published',
    redemptionHint:
      'You can redeem up to {{maxRedemptionAmount}} SAR for this purchase. A minimum of {{minAmount}} SAR must be paid',
  },
  nationalAddressPopup: {
    // Title
    titleRequired: 'National address required',
    // Banners
    bannerNonExistence:
      "We couldn't find your national address. Please upload your national address certificate to continue.",
    // Upload
    uploadLabel: 'Upload national address certificate',
    uploadDropzone: 'Drag file or click to upload',
    uploadRules: 'JPG, JPEG, PNG, PDF · Max 15 MB · Required',
    uploadHint:
      'Please enter your address details exactly as they appear on the certificate.',
    exampleTooltip: 'Example of a National Address certificate',
    // Fields
    city: 'City',
    district: 'District',
    street: 'Street',
    buildingNumber: 'Building Number',
    zipCode: 'Zip Code',
    additionalNumber: 'Additional Number',
    // Buttons
    cancel: 'Cancel',
    saveContinue: 'Save & continue to payment',
    // Save confirmation
    saveConfirmation: 'Are you sure you want to save the data?',
    saveSuccess: 'Data saved successfully',
    // Shared with MissingAddressDataPopup
    confirm: 'Save & continue to payment',
  },
  otpPopup: {
    verify: 'Verify',
    resend: 'Resend',
    countdownText: 'Will Expire in',
    expiryText: 'Expired OTP',
    incorrectOtpMessage: 'Incorrect OTP',
  },
  requiredInformation: {
    title: 'Required Information',
    description: 'Please provide the missing information below',
  },
} as const
